import React, { ReactNode } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { headerProps, headerTypographyProps } from '../styles/sxStyling';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

interface IAddButtonProps {
  onAdd?: () => void;
}

export function AddButton({ onAdd = () => navigate('new') }: IAddButtonProps) {
  const navigate = useNavigate();

  return (
    <Button onClick={onAdd} color="primary" variant="contained">
      Add
    </Button>
  );
}

interface IListHeaderProps {
  title: string;
  showFilterToggle?: boolean;
  onToggleFilters?: () => void;
  filtersOpen?: boolean;
  rightActions?: ReactNode;
}

export default function ListHeader({ title, showFilterToggle = true, onToggleFilters, filtersOpen = false, rightActions = (<AddButton />) }: IListHeaderProps) {


  return (
    <Box sx={headerProps}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography {...headerTypographyProps}>{title}</Typography>

        {showFilterToggle && (
          <IconButton
            size="small"
            onClick={onToggleFilters}
            color={filtersOpen ? 'primary' : 'default'}
            aria-label="Toggle filters panel"
            aria-pressed={!!filtersOpen}
          >
            <FilterAltIcon />
          </IconButton>
        )}
      </Box>

      {rightActions}
    </Box>
  );
}
